import React from 'react';
import { ArticleTaskCard } from 'components/ArticleTaskCard/ArticleTaskCard';
import { EncouragementTaskCard } from 'components/EncouragementTaskCard/EncouragementTaskCard';
import { ReminderTaskCard } from 'components/ReminderTaskCard/ReminderTaskCard';
import { StepCountCard } from 'components/StepCountCard/StepCountCard';
import { SurveyTaskCard } from 'components/SurveyTaskCard/SurveyTaskCard';
import {
  isPhysicalActivityTask,
  isBasicReminderTask,
  isContentTask,
  isEncouragementTask,
  isMedicationReminderTask,
  isSurveyTask,
  isQualtricsSurveyTask,
  isMedicationReminderGroupTask,
} from 'features/checklist/types/taskTypeGuards';

interface Props {
  task: Task;
  onClick: (taskId: number) => void;
}

const calculateStepProgress = (recordedSteps: number, stepGoal: number) => {
  const stepsProgress = (recordedSteps / stepGoal) * 100;
  // Bound the number between 0 and 100
  return Math.min(100, Math.max(0, stepsProgress));
};

export const ChecklistTaskComponent = ({ task, onClick }: Props) => {
  // TODO : To be refined while doing api integration
  const handleClick = () => {
    onClick(task.id);
  };

  return (
    <>
      {isPhysicalActivityTask(task) && (
        <StepCountCard
          stepsProgress={calculateStepProgress(task.recordedSteps ?? 0, task.stepGoal)}
          key={task.id}
          isCompleted={task.isCompleted}
          onClick={handleClick}
          recordedSteps={task.recordedSteps ?? 0}
        />
      )}
      {(isMedicationReminderTask(task) || isMedicationReminderGroupTask(task)) && (
        <ReminderTaskCard
          variant="medication"
          isCompleted={task.isCompleted}
          instruction={task.name}
          onClick={handleClick}
        />
      )}
      {isBasicReminderTask(task) && (
        <ReminderTaskCard
          variant="health"
          isCompleted={task.isCompleted}
          instruction={task.name}
          onClick={handleClick}
        />
      )}
      {(isSurveyTask(task) || isQualtricsSurveyTask(task)) && (
        <SurveyTaskCard
          surveyName={task.name}
          careProgramName={task.typeLabel}
          isCompleted={task.isCompleted}
          onClick={handleClick}
        />
      )}
      {isContentTask(task) && (
        <ArticleTaskCard
          articleName={task?.name}
          careProgramName={task?.careProgramName}
          isCompleted={task.isCompleted}
          onClick={handleClick}
        />
      )}
      {isEncouragementTask(task) && (
        <EncouragementTaskCard
          encouragementName={task.name}
          careProgramName={task?.careProgramName}
          isCompleted={task.isCompleted}
          onClick={handleClick}
        />
      )}
    </>
  );
};
